/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, Card, Form } from 'react-bootstrap';

import { Titre, Item, ComputeSurface } from '../Fonctions';

function Dimensions({ dimensions, largeur, setRangeLargeur, hauteur, setRangeHauteur, store_type }) {
	return (
		<Stack gap={2}>
			<Titre>Dimensions de la vitre</Titre>
			Attention : merci d’indiquer uniquement la dimension de la vitre (et non de la fenêtre complète avec sa menuiserie)
			<Card style={{ width: '95%' }}>
				<Card.Body>
					<Form.Group>
						<Item>Largeur</Item>
						<Form.Range value={largeur} step={10} min={dimensions[store_type]['largeur_min']} max={dimensions[store_type]['largeur_max']} onChange={(e) => setRangeLargeur(e.currentTarget.value)}/>
						<Stack direction='horizontal' gap={2}>
							<Form.Control style={{ width: 'min-content' }} type="number" value={largeur} min={dimensions[store_type]['largeur_min']} max={dimensions[store_type]['largeur_max']} onChange={(e) => setRangeLargeur(e.currentTarget.value)}/>
							<span>mm</span>
						</Stack>
					</Form.Group>
				</Card.Body>
			</Card>
			<Card style={{ width: '95%' }}>
				<Card.Body>
					<Form.Group>
						<Item>Hauteur</Item>
						<Form.Range value={hauteur} step={10} min={dimensions[store_type]['hauteur_min']} max={dimensions[store_type]['hauteur_max']} onChange={(e) => setRangeHauteur(e.currentTarget.value)}/>
						<Stack direction='horizontal' gap={2}>
							<Form.Control style={{ width: 'min-content' }} type="number" value={hauteur} min={dimensions[store_type]['hauteur_min']} max={dimensions[store_type]['hauteur_max']} onChange={(e) => setRangeHauteur(e.currentTarget.value)}/>
							<span>mm</span>
						</Stack>
					</Form.Group>
				</Card.Body>
			</Card>
			<ComputeSurface largeur={largeur} hauteur={hauteur}/>
		</Stack>
	);
}

export default Dimensions;
